export const statusError =[
    {code:0,message:'Nuestro servicio está experimentando una falla técnica. Inténtalo más tarde'},
    {code:400,message:'Nuestro servicio está experimentando una falla técnica. Inténtalo más tarde'},
    {code:401,message:'El tiempo de sesión ha expirado, inténtalo de nuevo.'},
    {code:403,message:'El tiempo de sesión ha expirado, inténtalo de nuevo.'},
    {code:404,message:'Nuestro servicio está experimentando una falla técnica. Inténtalo más tarde'},
];